import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-center justify-center p-4" };
const _hoisted_2 = { class: "relative w-full max-w-lg bg-white rounded-xl shadow-2xl p-6 flex flex-col gap-5" };
const _hoisted_3 = { class: "flex items-center justify-between" };
const _hoisted_4 = { class: "flex items-center gap-3" };
const _hoisted_5 = { class: "text-base font-semibold text-gray-900" };
const _hoisted_6 = { class: "text-sm text-gray-600" };
const _hoisted_7 = { class: "rounded-lg border border-gray-200 overflow-hidden" };
const _hoisted_8 = { class: "px-3 py-2 bg-gray-50 border-b border-gray-200" };
const _hoisted_9 = { class: "text-xs font-medium text-gray-500 uppercase tracking-wide" };
const _hoisted_10 = { class: "divide-y divide-gray-100 max-h-48 overflow-y-auto" };
const _hoisted_11 = { class: "flex flex-col min-w-0" };
const _hoisted_12 = { class: "text-sm text-gray-700 truncate" };
const _hoisted_13 = { class: "text-xs text-gray-400 truncate" };
const _hoisted_14 = { class: "flex justify-end" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeleteBlockedModal',
    props: {
        usages: {}
    },
    emits: ["close"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "absolute inset-0 bg-black/40",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center justify-center w-9 h-9 rounded-full bg-red-100" }, [
                                    _createElementVNode("svg", {
                                        class: "w-5 h-5 text-red-600",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "2",
                                        stroke: "currentColor"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                        })
                                    ])
                                ], -1)),
                                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("services.charges.modals.blocked_title")), 1)
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                class: "flex items-center justify-center w-7 h-7 text-gray-400 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
                            }, [...(_cache[4] || (_cache[4] = [
                                    _createElementVNode("svg", {
                                        class: "w-4 h-4",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        "stroke-width": "2",
                                        stroke: "currentColor"
                                    }, [
                                        _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            d: "M6 18 18 6M6 6l12 12"
                                        })
                                    ], -1)
                                ]))])
                        ]),
                        _createElementVNode("p", _hoisted_6, [
                            _createTextVNode(_toDisplayString(_ctx.$t("services.charges.modals.blocked_lead")) + " ", 1),
                            _createElementVNode("strong", null, _toDisplayString(__props.usages.length) + " " + _toDisplayString(__props.usages.length === 1 ? _ctx.$t("services.charges.modals.service_singular") : _ctx.$t("services.charges.modals.service_plural")), 1),
                            _createTextVNode(". " + _toDisplayString(_ctx.$t("services.charges.modals.blocked_tail")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("services.charges.modals.affected_services")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.usages, (usage) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: usage.serviceId,
                                        class: "px-3 py-2.5 flex items-center gap-2"
                                    }, [
                                        _cache[5] || (_cache[5] = _createElementVNode("svg", {
                                            class: "w-4 h-4 text-gray-400 shrink-0",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            "stroke-width": "1.5",
                                            stroke: "currentColor"
                                        }, [
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                                            })
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("span", _hoisted_12, _toDisplayString(usage.serviceName), 1),
                                            _createElementVNode("span", _hoisted_13, _toDisplayString(usage.orgName ?? _ctx.$t("services.charges.modals.no_organization")), 1)
                                        ])
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "px-5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('close')))
                            }, _toDisplayString(_ctx.$t("services.charges.actions.understood")), 1)
                        ])
                    ])
                ])
            ]));
        };
    }
});
